import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=ba8e526a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba8e526a')) {
      api.createRecord('ba8e526a', component.options)
    } else {
      api.reload('ba8e526a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=ba8e526a&", function () {
      api.rerender('ba8e526a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21dMXK0udbn1r/JS/comp/openstreetmap.vue"
export default component.exports